import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8, spacing24 } from 'approot/shared/styles/spacing.style';
import { grey2 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  DRAG_ITEM_SIZE,
  InteractiveDragContainer,
} from '../../../shared/interactive-drag-drop/interactive-drag.style';

export const InteractiveResponseDropItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: ${rem(spacing24)};
  flex-wrap: wrap;
  padding: 0 ${rem(spacing24)};
`;

export const InteractiveResponsePreviewDropItemContainer = styled(
  InteractiveResponseDropItemContainer
)`
  margin-bottom: 0;
  padding: ${rem(spacing8)} ${rem(spacing24)} 0 ${rem(spacing24)};
`;

export const InteractiveResponseScrollableItem = styled.li<{
  $isInFocus?: boolean;
  $index: number;
}>`
  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  display: block;
  margin-right: 0;
  padding: 0;
  height: ${rem(DRAG_ITEM_SIZE)};
  width: ${rem(DRAG_ITEM_SIZE)};
  min-height: ${rem(DRAG_ITEM_SIZE)};
  min-width: ${rem(DRAG_ITEM_SIZE)};

  ${({ $isInFocus }) =>
    $isInFocus
      ? `
    min-width: ${rem(200)};
    min-height: ${rem(200)};
  `
      : `
    min-width: ${rem(DRAG_ITEM_SIZE)};
    min-height: ${rem(DRAG_ITEM_SIZE)};
  `}

  ${InteractiveDragContainer} {
    ${({ $isInFocus }) =>
      $isInFocus &&
      `
      transform: scale(${200 / DRAG_ITEM_SIZE});
      transform-origin: -2px -2px;
    `}
  }
`;
